exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.picker-preview,.picker-preview--slick-item figure{background-color:#e3e3e3;background-position:50%;background-repeat:no-repeat;background-size:cover;cursor:pointer;height:0;margin:0 0 10px;padding-bottom:100%\n}\n.picker-preview--array{display:grid;grid-gap:10px;grid-template-columns:repeat(3,1fr)\n}\n.picker-preview--slick-item .img-block{position:relative\n}\n.picker-preview--slick-item .remove-button{background:#ccc;border:none;border-radius:none;cursor:pointer;font:inherit;font-size:15px;height:20px;line-height:1;padding:0;position:absolute;right:0;top:0;width:20px\n}", ""]);

// exports
